import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function SpotifyCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Connecting to Spotify...');
  const [error, setError] = useState(null);

  useEffect(() => {
    const code = searchParams.get('code');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setError(`Spotify authorization failed: ${errorParam}`);
      return;
    }

    if (!code) {
      setError('No authorization code received from Spotify');
      return;
    }

    // Exchange code for tokens
    const exchangeCode = async () => {
      try {
        setStatus('Exchanging authorization code...');
        const origin = window.location.origin;
        const response = await axios.get(`${API}/spotify/callback?code=${encodeURIComponent(code)}&origin=${encodeURIComponent(origin)}`);
        
        const { access_token, refresh_token, expires_in } = response.data;
        
        // Store tokens in localStorage
        localStorage.setItem('spotify_access_token', access_token);
        localStorage.setItem('spotify_refresh_token', refresh_token);
        localStorage.setItem('spotify_token_expires', Date.now() + (expires_in * 1000));
        
        setStatus('Connected! Redirecting...');
        
        // Redirect to background music page
        setTimeout(() => {
          navigate('/music/background');
        }, 1000);
      } catch (err) {
        console.error('Token exchange error:', err);
        setError(err.response?.data?.detail || 'Failed to connect to Spotify');
      }
    };

    exchangeCode();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <img src="/scorz-logo.png" alt="Scorz" className="h-16 mx-auto mb-8 brightness-0 invert" />
        
        {error ? (
          <div className="text-red-500">
            <p className="text-xl mb-4">{error}</p>
            <button
              onClick={() => navigate('/music/background')}
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            >
              Try Again
            </button>
          </div>
        ) : (
          <div className="text-white">
            <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-xl">{status}</p>
          </div>
        )}
      </div>
    </div>
  );
}
